// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-q_fK","galleryItem_borderTopRadius":"c-q_fL","galleryItem__image":"c-q_fM"};